import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { getGameRNG } from '../core/rng';

export const WeaponParachute: WeaponDefinition = {
  id: 'parachute',
  name: 'Parachute',
  icon: 'parachute.png',
  category: 'utility',
  maxAmmo: 2,
  maxUsesPerTurn: 1,
  powerCharging: false,
  timerAdjustable: false,
  showAimGuide: false,
  allowRetreat: false,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm } = ctx;

    if (worm.isGrounded) {
      return {
        success: false,
        message: 'Must be in the air to deploy parachute',
      };
    }

    if (worm.parachuteOpen) {
      return {
        success: false,
        message: 'Parachute already deployed',
      };
    }

    worm.parachuteOpen = true;

    const bonusWeapon = getGameRNG().next() < 0.5 ? 'dynamite' : 'mine';

    return {
      success: true,
      entities: [],
      message: `Parachute deployed! Bonus: ${bonusWeapon}`,
      bonusWeapon,
    };
  },
};
